import { Controller } from "@hotwired/stimulus"
import "./mobile_component.css"

export default class extends Controller {
  static targets = ["scroll", "tab"]

  connect() {
    this.scrollActiveIntoView()
  }

  scrollActiveIntoView() {
    if (!this.hasScrollTarget) return

    const active = this.tabTargets.find((tab) =>
      tab.classList.contains("mobile-nav-tab-active")
    )
    if (!active) return

    const offset =
      active.offsetLeft -
      this.scrollTarget.clientWidth / 2 +
      active.clientWidth / 2

    this.scrollTarget.scrollTo({ left: Math.max(0, offset), behavior: "instant" })
  }
}
